import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
  model,
  output,
} from '@angular/core';

@Component({
  selector: 'lib-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListItemComponent {
  showMoreVisible = input<boolean>();
  editVisible = input<boolean>();
  removeVisible = input<boolean>();
  hideClose = input<boolean>();
  actionVisible = input<boolean>();
  actionDisabled = input<boolean>();
  actionText = input<string>();
  actionCheckbox = input<boolean>();
  error = input<boolean>();
  @Input() editMode: boolean;
  onlyEditMode = input<boolean>();
  disabled = input<boolean>();
  toggleEditMode = input<boolean>();
  readOnlyState = input<boolean>();
  title = input<string>();
  showToggler = input<boolean>(false);
  togglerValue = model<boolean>(false);
  togglerTextInactive = input<string>();
  togglerTextActive = input<string>();
  isMobile = input<boolean>(false);

  edit = output<void>();
  remove = output<void>();
  action = output<void>();

  // eslint-disable-next-line @angular-eslint/no-output-native
  toggle = output<void>();

  showMore = false;

  onShowMore() {
    this.showMore = true;
  }

  toggleEdit() {
    if (this.toggleEditMode()) {
      if (this.editMode) {
        this.editMode = false;
      } else {
        this.showMore = false;
        this.editMode = true;
      }
    }
    this.edit.emit();
  }

  toggled() {
    this.toggle.emit();
  }

  onRemove() {
    this.remove.emit();
  }

  onAction() {
    this.action.emit();
  }
}
